"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldTransformHeightExclude = exports.FieldTransformSelectListReplace = exports.FieldTransformNumberInvert = exports.FieldTransformVectorInvert = exports.FieldTransform = void 0;
const core_api_1 = require("@ikegps/core-api");
class FieldTransform {
    constructor(fieldId, transform) {
        this.fieldId = fieldId;
        this.transform = transform;
    }
    static create(field, transform) {
        const transforms = {
            [core_api_1.IkeFieldType.VECTOR]: {
                invert: FieldTransformVectorInvert,
            },
            [core_api_1.IkeFieldType.NUMBER]: {
                invert: FieldTransformNumberInvert,
            },
            [core_api_1.IkeFieldType.SELECT_LIST]: {
                replace: FieldTransformSelectListReplace,
            },
            [core_api_1.IkeFieldType.HEIGHT]: {
                exclude: FieldTransformHeightExclude,
            },
        };
        // #FIXME Typescript cant determine the type of this variable (due to a bug in the compiler) so its defaulted
        //   to any. Its correct type is something along the lines of "Record<TransformType, FieldTransform<K, T>>"
        const fieldTypeTransforms = transforms[field.schema.type];
        if (!fieldTypeTransforms) {
            return null;
        }
        // #FIXME Typescript cant determine the type of this variable (due to a bug in the compiler) so its defaulted
        const transformClass = fieldTypeTransforms[transform.transform];
        if (!transformClass) {
            return null;
        }
        return new transformClass(field.id, transform);
    }
}
exports.FieldTransform = FieldTransform;
class FieldTransformVectorInvert extends FieldTransform {
    match(from) {
        return from.hasValue();
    }
    apply(to) {
        to.Mutator.reverse();
    }
}
exports.FieldTransformVectorInvert = FieldTransformVectorInvert;
class FieldTransformNumberInvert extends FieldTransform {
    match(from) {
        return from.hasValue();
    }
    apply(to) {
        to.Mutator.reverse();
    }
}
exports.FieldTransformNumberInvert = FieldTransformNumberInvert;
class FieldTransformSelectListReplace extends FieldTransform {
    match(from) {
        const toValue = this.transform.replace[from.value];
        return toValue != null;
    }
    apply(to) {
        var _a;
        const toValue = (_a = this.transform.replace[to.value]) !== null && _a !== void 0 ? _a : null;
        to.Mutator.manual(toValue);
    }
}
exports.FieldTransformSelectListReplace = FieldTransformSelectListReplace;
class FieldTransformHeightExclude extends FieldTransform {
    apply(to) {
        to.Mutator.manual(null);
    }
    match(_from) {
        return true;
    }
}
exports.FieldTransformHeightExclude = FieldTransformHeightExclude;
//# sourceMappingURL=field.transform.js.map